import { render, staticRenderFns } from "./ReferralStructure.vue?vue&type=template&id=73e27cbe&"
import script from "./ReferralStructure.vue?vue&type=script&lang=js&"
export * from "./ReferralStructure.vue?vue&type=script&lang=js&"
import style0 from "./ReferralStructure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports